import { gql } from '@grandvisionhq/graphql';

const storeOpeningTimesByCode = gql`
  fragment StoreOpeningTimesByCode on Store {
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      dateOpenClosed
      openClosed
      openClosedTime {
        open
        close
      }
    }
  }
`;
const GET_STORE_OPENING_TIMES_BY_CODE = gql`
  query GetStoreOpeningTimesByCode($code: Int) {
    store(code: $code) {
      ...StoreOpeningTimesByCode
    }
  }
  ${storeOpeningTimesByCode}
`;

export { GET_STORE_OPENING_TIMES_BY_CODE };
//# sourceMappingURL=get-store-opening-times.js.map
